import './Projects.css';

const PROJECTS = [
  {
    title: 'Bolst Tax — Make Tax Digital',
    client: 'Indigo', date: 'Nov 2025 — Present', live: true,
    role: 'Senior Software Engineer',
    tags: ['Angular 21','Supabase','Edge Functions','Stripe','Cursor IDE','MCP'],
    desc: 'HMRC-compliant Making Tax Digital platform for UK sole traders, landlords & subcontractors — enabling mandatory quarterly income reporting, Stripe subscription management, and a guided HMRC onboarding journey.',
    highlights: [
      'Architected the entire Angular 21 design system from scratch — component library, theming tokens & layout patterns',
      'Integrated Stripe payment gateway into onboarding flow, handling plan selection, card capture & payment confirmation',
      'Authored the full set of Cursor Rules for the project enabling consistent AI-assisted development across the team',
    ],
  },
  {
    title: 'Indigo Platform — Workforce Management',
    client: 'Indigo', date: 'Jun 2023 — Present', live: false,
    role: 'Senior Software Engineer',
    tags: ['.NET 6','Angular 14','SQL Server'],
    desc: 'UK workforce solutions platform specialising in CIS-compliant subcontractor engagement, payroll management & workforce compliance including the MyIndigo digital contractor tool.',
    highlights: [
      'Owned complete rebranding of contractor onboarding flow, reducing friction & aligning UI with updated brand guidelines',
      'Drove sprint planning & backlog refinement sessions, improving on-time delivery rate across the team',
      'Shipped multiple feature enhancements across compliance & payroll modules within agreed sprint cycles',
    ],
  },
  {
    title: 'Nova — Driver Compliance Platform',
    client: 'Indigo', date: 'Jun 2023 — Oct 2024', live: false,
    role: 'Senior Software Engineer',
    tags: ['.NET 8','Angular 17','SQL Server','Cosmos DB'],
    desc: 'Digital compliance platform for drivers & operators — continuous working practice assessment, dynamic agreement management, automated alerts, document sharing & identity/DBS verification.',
    highlights: [
      'Executed full-stack upgrade Angular 14→17 & .NET 6→8 with zero regression in production',
      'Designed & delivered reusable Angular UI component library cutting new feature development time significantly',
      'Delivered 10+ feature enhancements improving operator & driver usability based on client feedback',
    ],
  },
  {
    title: 'Medici ASP — Antimicrobial Stewardship',
    client: 'Asolva', date: 'Sep 2022 — Jun 2023', live: false,
    role: 'Senior Software Engineer',
    tags: ['.NET 6','Angular 14','SQL Server'],
    desc: 'Cloud-based healthcare SaaS enabling hospitals to achieve AUR reporting for NHSN compliance — with pre-built EHR integrations, dynamic pivot reports & role-based access control.',
    highlights: [
      'Engineered generic Angular dynamic form component — eliminated ~40% of repetitive form code across 5 modules',
      'Secured all API endpoints with JWT role-based auth & Angular AuthGuard — zero unauthorised access in QA & production',
      'Integrated SyncFusion Pivot Table with dynamic field config enabling analyst-built AUR reports without dev intervention',
    ],
  },
  {
    title: 'Vendor Portal Management',
    client: 'MRF', date: 'Sep 2021 — Sep 2022', live: false,
    role: 'Software Engineer',
    tags: ['.NET Core 3.1','Angular','Azure Logic Apps','Data Factory','SQL Server'],
    desc: 'Multi-plant procurement platform for MRF — vendor registration, PR–PO workflows, freight forwarding, SAP integration & ETL migration across geographically distributed manufacturing plants.',
    highlights: [
      'Built end-to-end SAP integration via Azure Logic Apps — automating PR import, multi-level approvals & PO sync',
      'Designed Azure Data Factory ETL pipeline migrating millions of rows between SQL Server databases',
      'Led 3-member sub-team for PR–PO & Freight Forwarder modules — delivered both to production on schedule',
    ],
  },
  {
    title: 'Internet Booking Engine — 4 Airlines',
    client: 'GoQuo', date: 'Jul 2017 — Sep 2021', live: false,
    role: 'Junior → Software Engineer',
    tags: ['C#','ASP.NET MVC','Vue.js','SQL Server','AWS S3'],
    desc: 'End-to-end flight booking platform for Malindo Air, Thai Lion Air, Fly Corporate & Bangkok Air — covering search, selection, payment, add-ons, vouchers & booking management across SE Asia.',
    highlights: [
      'Developed & shipped add-on, payment gateway, flight search & voucher modules supporting thousands of daily transactions',
      'Built interactive Vue.js add-on selection UI with real-time fare & tax breakdowns improving passenger experience',
      'Built Windows service for automated IIS Application Pool monitoring & recycling, improving uptime during high-traffic',
    ],
  },
];

export default function Projects() {
  return (
    <section id="projects" className="section-wrap">
      <div className="eyebrow-row">
        <div className="eyebrow-line" /><div className="eyebrow-txt">Projects</div><div className="eyebrow-line" />
      </div>

      <div className="projects-list">
        {PROJECTS.map(p => (
          <div key={p.title} className={`pcard card ${p.live ? 'live' : ''}`}>
            <div className="pcard-inner">
              <div className="pmeta">
                <div className="pmeta-badges">
                  {p.live && <span className="live-badge"><div className="live-dot" />Live</span>}
                  <span className="client-badge">{p.client}</span>
                </div>
                <div className="p-title">{p.title}</div>
                <div className="p-role">{p.role}</div>
                <div className="p-date">{p.date}</div>
                <div className="p-tags">{p.tags.map(t => <span key={t} className="tag">{t}</span>)}</div>
              </div>
              <div className="pdetail">
                <p className="p-desc">{p.desc}</p>
                <div className="hl-lbl">Key contributions</div>
                <div>{p.highlights.map(h => <div key={h} className="hl"><div className="hl-dot" /><span>{h}</span></div>)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
